function getEnumKeyByValue<T extends Record<string, string | number>>(
  enumObj: T,
  value: T[keyof T] | undefined
): string | undefined {
  if (value === undefined) return undefined;
  return Object.entries(enumObj).find(([, v]) => v === value)?.[0];
}

export default getEnumKeyByValue;
